module.exports = __webpack_public_path__ + "static/img/pg.png";